import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Layout } from './Layout';

const Title = styled.h1`
  cursor: default;
  font-family: var(--title-font);
  text-transform: uppercase;
`;

const Paragraph = styled.p`
  margin: 20px 0;
`;

const LastUpdated = styled.p`
  font-size: 0.85rem;
  color: #555;
`;

export const Privacy = () => {
  return (
    <Layout>
      <div>
        <title>Privacy Policy</title>
        <Title>Privacy Policy</Title>
        <LastUpdated>Last updated: July 2026</LastUpdated>
        <Paragraph>
          <Link to='/'>Back to home</Link>
        </Paragraph>

        <Paragraph>
          This is a personal portfolio website. It does not use cookies,
          analytics, advertising, or any tracking technology, and it does not
          collect, store, or share any personal data about visitors.
        </Paragraph>

        <h2>Data controller</h2>
        <Paragraph>
          Mikel Loidi Ardanaz (mikel@mloidi.com) is the data controller for
          this website.
        </Paragraph>

        <h2>What data is processed</h2>
        <Paragraph>
          This site collects no personal data through forms, cookies, or
          tracking scripts. All fonts and other assets are served directly
          from this site rather than from third-party CDNs, so your browser
          does not send information to any third party just by visiting.
        </Paragraph>
        <Paragraph>
          The only processing that occurs is standard technical logging
          performed by the hosting provider (Netlify) as part of delivering
          the site to your browser — for example, your IP address and
          request timestamp may briefly appear in server access logs. This is
          necessary to operate the site and is handled under Netlify's own
          privacy policy, available at{' '}
          <a
            href='https://www.netlify.com/privacy/'
            target='_blank'
            rel='noopener noreferrer'
          >
            netlify.com/privacy
          </a>
          .
        </Paragraph>

        <h2>Contacting me</h2>
        <Paragraph>
          The LinkedIn and email links on this site take you to a
          third-party service or your own email client. Any information you
          choose to share through them (for example, by sending an email) is
          governed by that service's own privacy practices, not this site's.
        </Paragraph>

        <h2>Your rights</h2>
        <Paragraph>
          Since this site does not collect or store personal data, there is
          generally nothing to access, correct, or delete. If you have any
          question about this policy or how this site works, contact{' '}
          <a href='mailto:mikel@mloidi.com'>mikel@mloidi.com</a>.
        </Paragraph>
      </div>
    </Layout>
  );
};
